export default __webpack_public_path__ + "static/Stephen_img-e88beeb521cda3fbcb9947065e467885.jpg";